import './style.scss'

interface CtaButtonProps {
	label: string
	icon?: string
	disabled?: boolean
	fullWidth?: boolean
	onClick: () => void
	size: 'small' | 'medium' | 'large'
	style?: 'primary' | 'secondary' | 'alt'
}

function CtaButton({label, icon, disabled, fullWidth, onClick, size = 'medium', style = 'primary'}: CtaButtonProps) {

	const buttonClickHandler = () => {
		if (!disabled) {
			onClick()
		}
	}

	return (
		<button 
			className={`cta-button ${disabled ? 'disabled' : ''} ${size} ${fullWidth ? 'cta-button-full-width' : ''} cta-button-${style}`}
			onClick={(event) => { 
				event.stopPropagation()
				buttonClickHandler() 
			}}
			disabled={disabled}
		>
			<div className='cta-button-label'>
				{label}
			</div>
			{icon && (
				<img 
					src={icon}
					className='cta-button-icon' 
					alt='cta button icon'
				/>
			)}
		</button>
	)
}

export default CtaButton
